function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareIconinline = function SvgShareIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 8a1.991 1.991 0 0 0-1.431.606L3.922 6.522a1.8 1.8 0 0 0 0-1.044l3.647-2.084A2 2 0 1 0 7 2a1.983 1.983 0 0 0 .078.523L3.431 4.606a2 2 0 1 0 0 2.788l3.647 2.084A1.979 1.979 0 0 0 7 10a2 2 0 1 0 2-2Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgShareIconinline;